import { Note } from '../../../utils/note'
import { type ItemVariant } from './types'
import { useBreadcrumb } from '../../../hooks/useBreadcrumb'
import { FilterHeadlineDivider } from './SectionDivider'
import { getNoteTitle } from './noteUtils'

type NoteHeaderRendererProps = {
  note: Note
  variant: ItemVariant
  showBreadcrumb?: boolean
}

export function NoteHeaderRenderer({
  note,
  variant,
  showBreadcrumb = true,
}: NoteHeaderRendererProps) {
  // Generate breadcrumb items using custom hook
  const breadcrumbItems = useBreadcrumb(note.recordName, {}, showBreadcrumb)
  const noteTitle = getNoteTitle(note)

  return (
    <div className='mb-2'>
      {/* Breadcrumb and Note title combined */}
      <h4 className='mb-1 text-xs text-gray-500 no-underline dark:text-gray-400'>
        {breadcrumbItems.length > 0 && (
          <>
            {breadcrumbItems.map((crumb, index) => (
              <span key={index} className='font-normal'>
                <span className='opacity-50'>{crumb}</span>
                <i className='fa-solid fa-chevron-right mx-1 scale-75 text-xs opacity-40' />
              </span>
            ))}
          </>
        )}
        <span className='font-bold'>{noteTitle}</span>
      </h4>

      {variant === 'filter' && <FilterHeadlineDivider />}
    </div>
  )
}
